<footer class="bg-primary text-white text-xs fixed bottom-0 right-0 left-0 py-1 px-8 flex items-center justify-between z-50">
  <div class="flex items-center">
    <img class="w-5 mr-2" src="/assets/img/logo-a-white.svg" alt="logo">
    <span>© Autoescuelas Alonso</span>
  </div>
  <p>Aviso Legal | Política de cookies | Política de privacidad</p>
</footer>
